import type { AutoCaptureEvent } from "@statsig/web-analytics";

const ELEMENT_CONTENT_METADATA_KEYS = ["content", "textContent", "selectedText"] as const;

/**
 * Removes text from autocapture events while preserving structural interaction
 * analytics. Statsig's filter callback does not expose the original DOM node,
 * so it cannot reliably detect privacy markers on an event target's ancestors.
 * Granular filtering depends on a DOM-aware, fail-closed mechanism that
 * Statsig's callback does not provide.
 */
export function sanitizeStatsigAutoCaptureEvent(event: AutoCaptureEvent): boolean {
  const metadata = event.metadata;
  if (!metadata) return true;

  for (const key of ELEMENT_CONTENT_METADATA_KEYS) delete metadata[key];
  return true;
}
